export const getNewAdvertising = ({ advertising }) => {
    return advertising.advertisingForm.values;
};
export const getAdvFormCallback = ({ advertising }) => {
    return advertising.advertisingForm.callback;
};

export const getFormState = ({ advertising }) => {
    return {
        editing: advertising.advertisingForm.editing,
        open: advertising.advertisingForm.open,
        id: advertising.advertisingForm.id,
    };
};
export const getFormStateSelector = (state) => getFormState(state);
export const getSelectedAdvSelector = (state) => state.advertising.selectedAdv;
export const getGlobalSelectionModeSelector = (state) => state.advertising.globalSelectionMode;
export const selectedFilmRelease = (state) => state.advertising.form.filmRelease;
export const selectFromDetails = (state) => state.advertising.fromDetails;
const reduceAttributesArrayToObject = (accumulator, currentValue) => {
    return {
        ...accumulator,
        [currentValue.attributeTypeId]: {
            active: true,
            value: currentValue.attributeValue,
        },
    };
};

export const fromExitingAdv = (adv, refreshViewPage, isClone) => {
    const contacts = adv.filmRelease.contacts.map((contact) => ({
        value: contact.id,
        label: `${contact.firstName} ${contact.lastName}`,
    }));

    let result = {
        advertisementTypeID: adv.advertisementTypeID,

        contacts,
        contact: contacts.find((contact) => contact.value === adv.contactID),

        filmRelease: { ...adv.filmRelease, value: adv.filmRelease.id, label: adv.filmRelease.title },

        reviews: [],
        id: null,
        quantity: adv.quantity || 1,
        refreshViewPage,
    };

    if (isClone) {
        result = {
            ...result,
            name: adv.name,
            exception: adv.exception,
            reported: adv.reported,
        };
    }

    return result;
};
export const formatAdvToEdit = (adv) => {
    const contacts = adv.filmRelease.contacts.map((contact) => ({
        value: contact.id,
        label: `${contact.firstName} ${contact.lastName}`,
    }));

    return {
        ...adv,
        advertisementTypeID: adv.advertisementTypeID,

        attributes: adv.attributeList.reduce(reduceAttributesArrayToObject, {}),
        codeValueList: adv.codeValueList.map((code) => ({ ...code, value: code.codeTypeID, label: "ISCI" })),
        contacts,
        contact: contacts.find((contact) => contact.value === adv.contactID),
        contactID: contacts.find((contact) => contact.value === adv.contactID),

        filmRelease: { ...adv.filmRelease, value: adv.filmRelease.id, label: adv.filmRelease.title },

        reviews: adv.reviews,
    };
};
